import React from 'react';
import { Box } from '@mui/material';
import { CreditEventSummaryList } from '@/features/credit-event-summary';

/**
 * Credit consumption "Overview" landing page. It hosts the Credit Event
 * Summary (overview cards + per-event summary table) — that screen was folded
 * in here and removed from the sidebar as its own entry.
 */
export const CreditConsumptionList: React.FC = () => (
  <Box>
    <CreditEventSummaryList />
  </Box>
);

export default CreditConsumptionList;
